<template>

  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'TemplateCategoryList' }">Template Categories</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form
      ref="template_category"
      :rules="rules.template_category"
      :model="template_category"
      :label-position="label_position">

      <el-form-item label="Name" prop="name">
        <el-input v-model="template_category.name"></el-input>
      </el-form-item>

      <el-form-item label="Sort Order" prop="sort_order">
        <el-input-number :min="0" v-model="template_category.sort_order"></el-input-number>
      </el-form-item>

      <el-form-item label="">
        <el-switch
          :active-value="1"
          :inactive-value="0"
          active-text="Enabled"
          inactive-text="Disabled"
          v-model="template_category.enabled">
        </el-switch>
      </el-form-item>

      <el-form-item>
          <el-button type="primary" @click="updateTemplateCategory('template_category')">Update</el-button>
      </el-form-item>

    </el-form>

    <pre v-if="config.debug">{{$data}}</pre>

  </div>

</template>

<style>

</style>

<script>
  import Config from '@/store/Config.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';

  export default {
    data: function() {
      return {
        config: Config.config,
        page_alias: 'Add Template Category',
        page_slug: 'add-template-category',
        label_position: 'top',
        loading: false,
        rules: {
          template_category: {
            name: [
              {required: true, message: 'Please Enter Corporation Name', trigger: 'blur'}
            ],
            sort_order: [
              {required: true, message: 'Please Select Sort Order', trigger: 'blur'}
            ],
            is_hidden: [
              {required: true, message: 'Please Select Sort Order', trigger: 'blur'}
            ],
          }
        },

        template_category: {
          name: '',
          sort_order: '',
          is_hidden: '',
          updated_user_id: ''
        },
      };  
    },

    mounted: function() {
      const me = this;
      me.getTemplateCategory();
    },

    methods: {
      getTemplateCategory: function() {
        console.log('Get Template Function');
        const me = this;
        me.loading = true;
        me.$http.get(me.config.api + 'templateCategory/{id}', {params: {id : me.$route.params.id}}).then(
        response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          me.template_category = response.body.data;
          me.loading = false;
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
          me.$notify({
            title: 'Error',
            message: response.statusText,
            stype: 'error'
          });
          me.loading = false;
        });
      },

      updateTemplateCategory: function(formName) {
        console.log('Update Template Category Function');
        const me = this;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            var jwt = Utils.decodejwt();
            me.template_category.updated_user_id = jwt.sub;   
            me.$http.put(me.config.api + 'templateCategory/{id}', me.template_category, {params: {id : me.$route.params.id}}).then(
            response => {
              console.log('Success Putting Data')  
              console.log(response.status);
              console.log(response.statusText);

              me.getTemplateCategory();

              me.$notify({
                  title: 'Success',
                  message: 'The Template Category Was Updated',
                  type: 'success'
              });
            }, response => {
              console.log('Error Putting Data');
              console.log(response.status);
              console.log(response.statusText);
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });   
      },

      resetForm(formName) {
        const me = this;
        this.$refs[formName].resetFields();
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/template-categories/TemplateCategoryEdit.vue